import { Button, Form, Input, Modal, Select } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import {
    useCreatePromptMutation,
    useFetchDefaultPromptsQuery,
    useFetchPromptHistoryQuery,
} from '../../../store/apis/prompt.api'
import { openNotificationWithIcon } from '../../../utils/notification.helper'

export const ManagePromptsModal = ({ onClose }) => {
    const { data: defaultPrompts, isLoading: isLoadingDefaultPrompts } = useFetchDefaultPromptsQuery()
    const [selectedPromptName, setSelectedPromptName] = useState(null)
    const [selectedPromptHistoryId, setSelectedPromptHistoryId] = useState(null)
    const [form] = Form.useForm()
    const [createPromptMutation, { isLoading: isCreatingPrompt }] = useCreatePromptMutation()

    const selectedPrompt = useMemo(
        () => defaultPrompts?.find(prompt => prompt.name === selectedPromptName),
        [defaultPrompts, selectedPromptName],
    )

    const { data: promptHistory, isLoading: isLoadingPromptHistory } = useFetchPromptHistoryQuery(
        {
            promptName: selectedPromptName,
        },
        {
            skip: !selectedPromptName,
        },
    )

    useEffect(() => {
        if (selectedPromptHistoryId) {
            const prompt = promptHistory?.find(prompt => prompt.id === selectedPromptHistoryId)

            if (prompt) {
                form.setFieldsValue({
                    prompt: prompt.prompt,
                })
            }
        }
    }, [selectedPromptHistoryId, promptHistory])
    
    useEffect(() => {
        if (promptHistory?.length) {
            setSelectedPromptHistoryId(promptHistory[0].id)
        }
    }, [promptHistory])

    useEffect(() => {
        if (selectedPrompt) {
            form.setFieldsValue({
                prompt: '',
            })
            setSelectedPromptHistoryId(null)
        }
    }, [selectedPromptName])
    
    const onSavePrompt = async values => {
        try {
            const createdPrompt = await createPromptMutation({
                name: selectedPromptName,
                prompt: values.prompt,
            }).unwrap()

            setSelectedPromptHistoryId(createdPrompt.id)
        } catch (error) {
            openNotificationWithIcon('error', 'Error saving prompt', error)
        }
    }

    return (
        <Modal onClose={onClose} onCancel={onClose} title='Manage Prompts' open footer={null}>
            <Select
                style={{ width: '300px' }}
                options={defaultPrompts?.map(prompt => ({
                    label: prompt.friendlyName,
                    value: prompt.name,
                }))}
                onChange={setSelectedPromptName}
                loading={isLoadingDefaultPrompts}
            />
            {selectedPrompt && (
                <div>
                    <p>{selectedPrompt.description}</p>
                    <p>Previous versions:</p>
                    <Select
                        style={{ width: '300px' }}
                        loading={isLoadingPromptHistory}
                        options={promptHistory?.map(prompt => ({
                            label: `${prompt.createdAt} (${prompt.userId ? 'User' : 'System'})`,
                            value: prompt.id,
                        }))}
                        value={selectedPromptHistoryId}
                        onChange={setSelectedPromptHistoryId}
                    />
                    <Form form={form} onFinish={onSavePrompt} layout='vertical' style={{ marginTop: 16 }}>
                        <Form.Item name='prompt' label='Prompt'>
                            <Input.TextArea style={{ minHeight: 300 }} />
                        </Form.Item>
                        <Button type='primary' htmlType='submit' loading={isCreatingPrompt}>
                            Save
                        </Button>
                    </Form>
                </div>
            )}
        </Modal>
    )
}
